<template>
    <div>
        <v-container class="app-breadcrumbs-container">
            <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
                <v-icon slot="divider">chevron_right</v-icon>
                <template slot="item" slot-scope="props">
                    <router-link
                        :to="props.item.to"
                        :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
                    >
                        {{ props.item.text }}
                    </router-link>
                </template>
            </v-breadcrumbs>
        </v-container>
        <div class="main-title">
            <v-container fill-height>
                <v-layout align-center>
                    {{ $t("address_create.title") }}
                </v-layout>
            </v-container>
        </div>

        <v-container>
            <div>
                <GmapMap
                    style="width: 100%; height: 350px;"
                    :zoom="14"
                    :center="center"
                >
                    <GmapMarker
                        v-for="(marker, index) in markers"
                        :key="index"
                        :position="marker.position"
                    />
                    <GmapMarker
                        label="★"
                        :position="center"
                        :clickable="true"
                        :draggable="true"
                        @dragend="handleDrag"
                    />
                </GmapMap>
            </div>
        </v-container>
        <v-container class="lost-container">
            <v-form ref="form">
                <v-container>
                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="contact"
                                ref="contact"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('address.name')"
                                required
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="phone"
                                ref="phone"
                                :rules="phoneRules"
                                validate-on-blur
                                :label="$t('address.phone')"
                                required
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="address1"
                                v-if="deliveryType == 0"
                                ref="address1"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('address.address1')"
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="city"
                                v-if="deliveryType == 0"
                                ref="city"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('address_create.city')"
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="zipcode"
                                v-if="deliveryType == 0"
                                ref="zipcode"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('address.zipcode')"
                                clearable
                                :required="deliveryType == 0"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md4>
                            <v-switch
                                v-model="defaultAddress"
                                :label="$t('address_create.default')"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-layout justify-start>
                <v-flex shrink mr-4>
                    <button class="button shadow" @click="submit">
                        {{ $t("address.btn") }}
                    </button>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="showTip" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>{{ tip }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-actions>
                    <v-btn color="primary" flat @click="showTip = false">
                        {{ $t("common.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import address from "../../api/address";
import axios from "axios";

const instance = axios.create();
import {mapState, mapMutations} from "vuex";

instance.defaults.headers.common = null;
export default {
    data() {
        return {
            nameRules: [value => !!value || this.$t("login.rules")],
            phoneRules: [
                value => !!value || this.$t("login.rules"),
                value => /^[679]\d{8}$/.test(value) || this.$t("common.phone_rule")
            ],
            contact: "",
            phone: "",
            zipcode: "",
            address1: "",
            city: "",
            defaultAddress: true,
            showTip: false,
            tip: "",
            markers: [],
            place: null,
            center: {lat: 40.37816496854541, lng: -3.6536622047424316}
        };
    },

    created() {
        console.log("是否登录", this.isLogin);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const lat = parseFloat(position.coords.latitude);
                const lng = parseFloat(position.coords.longitude);

                this.center = {
                    lat,
                    lng
                };
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
        this.loadDetail(this.center.lat, this.center.lng);
    },
    computed: {
        ...mapState(["deliveryType", "isLogin"]),
        form() {
            return {
                contact: this.contact,
                phone: this.phone,
                city: this.city,
                zipcode: this.zipcode,
                address1: this.address1
            };
        },
        breadcrumbs() {
            return [
                {
                    to: {name: "account/info"},
                    disabled: false,
                    text: this.$t("breadcrumbs.account")
                },
                {
                    to: {name: "address"},
                    disabled: false,
                    text: this.$t("breadcrumbs.address_list")
                },
                {
                    to: {name: "order/list"},
                    disabled: true,
                    text: this.$t("breadcrumbs.address_create")
                }
            ];
        }
    },
    methods: {
        ...mapMutations(["setZipCode"]),
        submit() {
            let isFull = true;
            let list = [];

            if (this.deliveryType == 0) {
                list = ["contact", "phone", "zipcode"];
            } else {
                list = ["contact", "phone"];
            }

            list.forEach(f => {
                if (!this.form[f]) {
                    this.formHasErrors = true;
                    this.$refs[f].validate(true);
                    isFull = false;
                }
            });

            if (isFull) {
                this.createAddress();
            }
        },
        async createAddress() {
            try {
                const res = await address.createAddress({
                    ...this.form,
                    latitude: this.center.lat,
                    longitude: this.center.lng,
                    defaultAddress: this.defaultAddress
                });
                if (this.isLogin == false) {
                    let adress = JSON.stringify(res.data.data);
                    localStorage.setItem("addressList", adress);
                    this.setZipCode(this.zipcode);
                }
                // console.log("adress", res.data.data);
                if (res.data.isError) {
                    this.tip = res.data.msg;
                    this.showTip = true;
                    return;
                }

                const {createSuccessRedirectType} = this.$route.query;

                if (createSuccessRedirectType === "back") {
                    this.$router.back();
                    return;
                }

                this.$router.push({name: "address"});
            } catch (e) {
                this.tip = e.response.data.msg;
                this.showTip = true;
            }
        },

        handleDrag(position) {
            this.loadDetail(position.latLng.lat(), position.latLng.lng());
            this.center = {
                lat: position.latLng.lat(),
                lng: position.latLng.lng()
            };
        },

        async loadDetail(lat, lng) {
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBHHR5duzSnYc-gP8ZT5TbJr5Yf2SkVGUQ&language=es`;
            instance
                .get(url, {
                    "access-control-request-headers": "Content-Type"
                })
                .then(response => {
                    if (response.data.status === "OK") {
                        const {results} = response.data;

                        if (results.length === 0) {
                            return;
                        }

                        // const address = results[0].address_components || [];
                        //
                        // this.address1 = this.getAddressName(address, ["route"]);
                        // this.city = this.getAddressName(address, [
                        //     "locality",
                        //     "administrative_area_level_2"
                        // ]);
                        // this.zipcode = this.getAddressName(address, ["postal_code"]);
                    } else {
                        console.log("error");
                    }
                });
        },

        getAddressName(address, type) {
            const result = address.find(item => {
                return (
                    item.types.findIndex(typeName => {
                        return type.includes(typeName);
                    }) > -1
                );
            });

            return result ? result.long_name : "";
        }
    }
};
</script>

<style scoped lang="sass" src="./create.sass"></style>
